/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifacts_Loading_ArtifactInputs */



/**
* | output |
* | --- |
* | "Loading artifact..." |
*
* @param {Artifacts_Loading_ArtifactInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_loading_artifact = /** @type {((inputs?: Artifacts_Loading_ArtifactInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Loading_ArtifactInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Artefakt wird geladen...")
	return /** @type {LocalizedString} */ ("Loading artifact...")
});